import { useCallback, useEffect, useRef } from 'react'
import { useErrorBanner } from './useErrorBanner'

export const useSafeErrorBanner = () => {
	const { showError } = useErrorBanner()
	const lastErrorRef = useRef(null)
	const resetTimerRef = useRef(null)

	useEffect(() => {
		return () => {
			if (resetTimerRef.current) {
				clearTimeout(resetTimerRef.current)
			}
		}
	}, [])

	const showErrorSafe = useCallback(
		msg => {
			const text = String(msg || '').trim()
			if (!text) return
			if (lastErrorRef.current === text) return
			lastErrorRef.current = text
			showError(text)
			if (resetTimerRef.current) {
				clearTimeout(resetTimerRef.current)
			}
			resetTimerRef.current = setTimeout(() => {
				lastErrorRef.current = null
				resetTimerRef.current = null
			}, 2000)
		},
		[showError],
	)

	return { showErrorSafe }
}
